<template>
  <div class="states-dropdown">
    <select v-model="selectedState">
      <option
        v-for="(value, key) in states" 
        v-if="isActive(key)"
        :value="key"
      >{{ value }}</option>
    </select>
    
    <div class="state-info" v-if="isActive(selectedState)">
      <b class="state-info__head">{{ currentStateName }} Utilities <small>(select one)</small></b>
      <ul class="state-info__list">
        <li class="state-info__item"
          v-for="utility in currentUtilities"
        >
          <a href="#" class="state-info__link"
            @click.prevent="
              setUtility({
                id: utility.id, 
                code: utility.code, 
                name: utility.name, 
                state: utility.state 
              })">{{ utility.name }}<i class="fa fa-angle-right"></i></a>      
        </li>
      </ul><!--/.states-dropdown__list-->
    </div><!--/. state-info-->
  </div><!--/.states-dropdown-->
</template>

<script>

import Vue from 'vue'
import axios from 'axios'

export default {
  props: {
    utilities: {
      type: [Object, Array]
    }
  },
  data() {
    return {
      selectedState: '',
      states: {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PA': 'Pennsylvania',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
      }
    }
  },
  computed: {
    currentUtilities() {
      if (this.isActive(this.selectedState)) {
        return this.utilities[this.selectedState]
      }
    },
    currentStateName() {
      if (this.isActive(this.selectedState)) {
        return this.states[this.selectedState]
      }
    }
  },
  methods: {
    isActive(abbr) {
      if (this.utilities[abbr]) {
        return true
      }
      return
    },
    setUtility(data) {
      if (data.id && data.name) {

        // Check plan level utility is subscribed at
        axios.get('/pricing-calculator/me/utilities/' + data.id + '/get-plan')
          .then(response => {   
            let utilityPlanData = {
              id: data.id,
              name: data.name,
              plan: {
                name: response.data.name,
                slug: response.data.slug,
              }
            }

            data.planData = utilityPlanData

            this.$store.dispatch('setUtility', data)
          })
      }
    },
  }
}
</script>
